<template>
    <div id="review" class="tab-pane fade " v-if="product != null && product.description != null"
        :class="activeTab === 'review' ? 'in active show' : ''">
        <div class="fontsize-small text-color-666 text-justify line-height2 py-3 px-0 px-md-3"
            v-html="product.description">
        </div>
        <div>
            <ProductComments :activeTab="'comments'" :product="product" />

        </div>
    </div>
</template>
<script>
import ProductComments from "@/parts/Front/components/productDetail/ProductComments";
import config from "../../../../config";
export default {
    props: ['activeTab', 'product'],
    components: {

        ProductComments,


    },
    mounted() {
        setTimeout(() => {
            let images = document.querySelectorAll("#review img");

            for (let index = 0; index < images.length; index++) {
                images[index].src =
                    config.baseUrlImage +
                    images[index].src.slice(images[index].src.indexOf("/upload"));
            }
        }, 500);
    }
}
</script>
<style>
#review ul,
#review ol {
    list-style-position: inside;
}

/*#review h1{
    font-size: 2rem;
}
#review h2{
    font-size: 1.8rem;
}
#review h3{
    font-size: 1.7rem;
}
#review h4{
    font-size: 1.6rem;
}
#review h5{
    font-size: 1.5rem;
}
#review h6{
    font-size: 1.4rem;
}*/
@media screen and (max-width:600px) {
    /* #review h1{
        font-size: 1.8rem;
    }
    #review h2{
        font-size: 1.7rem;
    }
    #review h3{
        font-size: 1.6rem;
    }
    #review h4{
        font-size: 1.5rem;
    }
    #review h5{
        font-size: 1.4rem;
    }
    #review h6{
        font-size: 1.3rem;
    }*/
}
</style>
